import loadable from '@loadable/component';
import FullPageLoader from '../../components/UIElements/Loader/fullPageLoader';

export const WillCallList = loadable(() => import('./List'), {
  fallback: <FullPageLoader />,
});
